import React from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default () => {
  return (
    <APIDocsBlock>
      <div>
        <div className="heading">Delete post</div>
        <div className="text">Deletes an existing post.</div>
        <APIDocsTable
          title="Arguments"
          rows={[
            {
              description: 'Your secret API key.',
              heading: 'apiKey',
              subheading: 'string',
            },
            {
              description: 'The unique identifier of the post.',
              heading: 'postID',
              subheading: 'string',
            },
          ]}
        />
        <div className="subheading">Returns</div>
        <div className="text">Returns "success" if the post was deleted successfully.</div>
      </div>
      <div>
        <div className="text">Endpoint</div>
        <Highlight lang="http">https://canny.io/api/v1/posts/delete</Highlight>
        <APIDocsMethod />
        <APIDocsCurl
          path="https://canny.io/api/v1/posts/delete"
          body={`-d '{
    "apiKey": "YOUR_API_KEY",
    "postID": "553c3ef8b8cdcd1501ba1238"' \\
    -H "Content-Type: application/json"`}
        />
        <div className="text">Example Response</div>
        <Highlight lang="json">success</Highlight>
      </div>
    </APIDocsBlock>
  );
};
